// extracted by mini-css-extract-plugin
export default {"checkmark":"_3_YZ","checkmark_path":"_1Yvl"};